import styled from 'styled-components';

export const FiltersWrapper = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-items: left;
  grid-gap: ${({ theme }) => theme.space[5]}px;
  position: relative;
`;
